module.exports = __webpack_public_path__ + "938028261e55a618744621ee165b9334.svg";